module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"runningTipsTitle":"数据处理中...","successTipsTitle":"数据处理完成","errorTipsTitle":"数据处理失败","errorTips":"数据处理失败，请重新试一试"},"en":{"runningTipsTitle":"Processing...","successTipsTitle":"Data processing completed","errorTipsTitle":"Data processing failed","errorTips":"Data processing failed, please try again"}}')
  delete Component.options._Ctor
}
